import { Prisma } from "@prisma/client";

export const sitemapEventValues = Prisma.validator<Prisma.EventDefaultArgs>()({
  select: {
    slug: true,
    updatedAt: true,
  },
});

export type SitemapEventType = Prisma.EventGetPayload<
  typeof sitemapEventValues
>;
